import { API_AUTH } from "./common";

const THUCHINGOAILEApi = {
  list: ({
    tenKH,
    loaiKH,
    tinhtrangKH,
    trangthaiKH,
    nguonKH,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `quanlythuchi/thu-chi-ngoai-le?tenKH=${tenKH}&loaiKH=${loaiKH}&tinhtrangKH=${tinhtrangKH}&trangthaiKH=${trangthaiKH}&nguonKH=${nguonKH}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
};

export default THUCHINGOAILEApi;
